import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17c86194"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mian-wrap" }
const _hoisted_2 = { class: "search-wrap" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "detail-info" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "title-val xag-ellipsis" }
const _hoisted_7 = { class: "address-text" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "empty-text xag-flex-center"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "暂无分经销商信息")
], -1))
const _hoisted_11 = [
  _hoisted_10
]

import { StringObject } from '@/types/public'
import { commonErrorHandle } from '@/utils/error-handle'
import { AuthClientItem } from '@/types/agricultura-loan'
import { getAuthClientList } from '@/apis/agricultura-loan'
import { List, Search, Radio, RadioGroup, Loading } from 'vant'
import { withDefaults, ref, computed, watch, onUnmounted } from 'vue'
import useCommonList, { PageListResut } from '@/compositions/useCommonList'
import PopupWrap from '@/components/popup/common-wrap.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'distributor-select',
  props: {
    visible: { type: Boolean, default: false },
    activeKey: { default: '1' },
    activeText: { default: '' }
  },
  emits: ['update:visible', 'update:activeKey', 'update:activeText'],
  setup(__props: any, { emit: emits }) {

const props = __props as { visible: boolean, activeKey: string, activeText: string };




const popupSelectKey = ref('')
const searchValue = ref('')

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      popupSelectKey.value = props.activeKey
    }
  }
)
function startSearch() {
  // 搜索经销商
  // onRefresh()
  resetSearch()
}

async function queryList(params: any) {
  try {
    const data = await getAuthClientList({
      keyword: searchValue.value,
      ...params,
    })
    return data
  } catch (error) {
    commonErrorHandle(error)
    return Promise.reject(error)
  }
}

const {
  refreshing,
  loading,
  requestError,
  resetSearch,
  finished,
  onRefresh,
  dataList,
  queryHandle,
  finishedText,
  unshiftDataList,
} = useCommonList<AuthClientItem, any>(queryList, {
  emptyText: '暂无可选数据',
})

// 防抖搜索
const timeoutId = ref<number | null>(null)
const debouncedResetSearch = () => {
  if (timeoutId.value) clearTimeout(timeoutId.value)
  timeoutId.value = setTimeout(() => {
    resetSearch()
  }, 500)
}

watch(searchValue, () => {
  debouncedResetSearch()
})

onUnmounted(() => {
  if (timeoutId.value) clearTimeout(timeoutId.value)
})

const renderList = computed(() => {
  return dataList.value
})
const distributorGuidTextMap = computed(() => {
  return dataList.value.reduce((result, item) => {
    result[item.client_guid] = item.client_name
    return result
  }, {} as StringObject)
})
// 确认选择经销商
function clickHandle(item: AuthClientItem) {
  popupSelectKey.value = item.client_guid
}

function updateShowHandle(visible: boolean) {
  emits('update:visible', visible)
}

function confirmSelect() {
  emits('update:visible', false)
  emits('update:activeKey', popupSelectKey.value)
  emits('update:activeText', distributorGuidTextMap.value[popupSelectKey.value])
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupWrap, {
    show: props.visible,
    "safe-area-inset-bottom": "",
    title: "选择分经销商",
    headerStyle: {
      backgroundColor: 'white',
    },
    "onUpdate:show": updateShowHandle
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Search), {
            modelValue: searchValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
            placeholder: "输入关键词",
            onSearch: startSearch
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_unref(List), {
          loading: _unref(loading),
          "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null)),
          error: _unref(requestError),
          "onUpdate:error": _cache[3] || (_cache[3] = ($event: any) => (_isRef(requestError) ? (requestError).value = $event : null)),
          finished: _unref(finished),
          offset: 200,
          "finished-text": _unref(finishedText),
          "error-text": "加载失败",
          onLoad: _unref(queryHandle),
          class: _normalizeClass(["list-container", _unref(renderList).length === 0 ? 'empty-wrap' : ''])
        }, {
          finished: _withCtx(() => [
            (_unref(renderList).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(finishedText)), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(RadioGroup), {
              class: "xa-radio-group",
              "checked-color": "#00C378",
              modelValue: popupSelectKey.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((popupSelectKey).value = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(renderList), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "distributor-item van-hairline--bottom",
                    key: item.client_guid,
                    onClick: _withModifiers(($event: any) => (clickHandle(item)), ["stop"])
                  }, [
                    _createVNode(_unref(Radio), {
                      name: item.client_guid,
                      class: "radio-item",
                      iconSize: "18px"
                    }, null, 8, ["name"]),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(item.client_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(item.address), 1)
                    ])
                  ], 8, _hoisted_3))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["loading", "error", "finished", "finished-text", "onLoad", "class"]),
        _createVNode(CommonFooterNextButton, {
          title: "确定",
          onClick: confirmSelect
        })
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})